/**
 * Чистая логика умного поиска сущностей при создании исполнителя.
 * HTTP-оркестрация: entitySmartSearchClient.mjs + entitySmartSearchApi.js.
 */
import { normalizePlateNumber } from '../pages/securityCheck/helpers/executorSearchPayload.mjs'

export const SUGGESTION_LIMIT = 12

/**
 * @param {string} model
 * @param {string} query
 * @param {object} [options]
 * @param {(number|string)} [options.companyId] — для менеджеров с пустым query
 *   фильтрует список по текущей компании на бэке; при непустом query игнорируется.
 * @returns {null | { kind: 'list', path: string, params: object, itemsKey: string } | { kind: 'managers', query: string }}
 */
export function buildEntitySearchCall(model, query, options = {}) {
  const raw = String(query || '').trim()
  const companyId = options.companyId

  if (model === 'companies') {
    if (!raw) return null
    return {
      kind: 'list',
      path: 'companies/list',
      params: { search: raw, page: 1, per_page: SUGGESTION_LIMIT },
      itemsKey: 'companies',
    }
  }

  if (model === 'drivers') {
    if (!raw) return null
    return {
      kind: 'list',
      path: 'drivers/list',
      params: { search: raw, page: 1, per_page: SUGGESTION_LIMIT },
      itemsKey: 'drivers',
    }
  }

  if (model === 'cars' || model === 'trailers') {
    if (!raw) return null
    const plate = normalizePlateNumber(raw) || raw
    return {
      kind: 'list',
      path: 'cars/list',
      params: {
        search: plate,
        is_trailer: model === 'trailers',
        page: 1,
        per_page: SUGGESTION_LIMIT,
      },
      itemsKey: 'cars',
    }
  }

  // managers — server-side search через /managers/list:
  //   • непустой query  → params.search (backend trigram ILIKE по name/phone/email)
  //   • пустой query    → params.company_id (фильтр по текущей компании)
  // Раньше было kind:'managers' с клиентской фильтрацией первых 100 записей —
  // это ломалось на больших БД (6592 менеджера, нужный не попадал в первые 100).
  if (model === 'managers') {
    const params = { page: 1, per_page: SUGGESTION_LIMIT }
    if (raw) {
      params.search = raw
    } else if (companyId != null && companyId !== '') {
      params.company_id = companyId
    } else {
      return null
    }
    return { kind: 'list', path: 'managers/list', params, itemsKey: 'managers' }
  }

  return null
}

export function pickListItems(call, data) {
  if (!call || call.kind !== 'list') return []
  const items = data?.[call.itemsKey]
  return Array.isArray(items) ? items : []
}

export function filterManagersByQuery(list, query, limit = SUGGESTION_LIMIT) {
  const raw = String(query || '').trim()
  const source = Array.isArray(list) ? list : []

  // Пустой query → возвращаем полный список (до limit). Бэкенд уже отфильтровал
  // по company_id в entitySmartSearchClient.loadManagers.
  if (!raw) return source.slice(0, limit)

  const q = raw.toLowerCase()
  const phoneDigits = raw.replace(/\D/g, '').slice(-10)

  return source
    .filter((item) => {
      const name = String(item?.name || '').toLowerCase()
      const phone = String(item?.phone || '')
      if (name.includes(q)) return true
      if (phoneDigits && phone.replace(/\D/g, '').includes(phoneDigits)) return true
      return false
    })
    .slice(0, limit)
}
